import { privateFetch } from "api/privateFetch";

/**
 * Get parent schedules
 * @param {string} id Parent ID
 * @param {string} courseId course ID
 * @returns {Promise<Response>} Response
 */
const tutorsForSession = async (id, courseId) => {
  const { data } = await privateFetch.get(
    `parent/${id}/tutorsforsession/${courseId}`
  );
  return data;
};

export default tutorsForSession;
